export default __webpack_public_path__ + "static/media/banner.4c143202.png";